import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import { HistoryAction, HistoryWithState } from "@/mk2/services/browserHistory";

/**
 * Inject history API to all actions
 */
export function createHistoryMiddleware<DispatchExt = {}, S = any, D extends Dispatch = Dispatch>(
    history: HistoryWithState,
): Middleware<DispatchExt, S, D> {
    return (api: MiddlewareAPI<D, S>) =>
        (next: Dispatch<AnyAction>) =>
        (action: AnyAction & HistoryAction): AnyAction & HistoryAction => {
            action.history = history;
            return next(action);
        };
}
